import {
  BaggageSelectionState,
  type ChildMachineConfig,
  ParentState,
} from "@checkout/types";
import { merge } from "lodash-es";
import { ActionTypes } from "./actions";
import { BaggageEventTypes } from "./events";

export const getMachineState = (config: ChildMachineConfig) => ({
  initial: BaggageSelectionState.route,
  entry: [ActionTypes.initSelectedBaggage, ActionTypes.setCheckedBagsPrices],
  states: merge(
    {
      [BaggageSelectionState.route]: {
        always: [
          {
            target: BaggageSelectionState.idle,
          },
        ],
      },
      [BaggageSelectionState.idle]: {
        on: {
          [BaggageEventTypes.SELECT_BAGGAGE]: {
            actions: [
              ActionTypes.selectBaggage,
              ActionTypes.resetEditBaggageFromReview,
            ],
          },
          [BaggageEventTypes.NEXT]: {
            actions: ActionTypes.resetEditBaggageFromReview,
            target:
              config.nextState ||
              `#${config.parentMachineId}.${ParentState.review}`,
          },
          [BaggageEventTypes.SKIP_BAGGAGE_SELECTION]: {
            actions: [
              ActionTypes.setSkipBaggageSelection,
              ActionTypes.resetSelectedBaggage,
            ],
          },
          [BaggageEventTypes.PREVIOUS]:
            config.previousState ||
            `#${config.parentMachineId}.${ParentState.passengerInformation}`,
        },
      },
      [BaggageSelectionState.error]: {
        on: {
          [BaggageEventTypes.NEXT]: config.nextState,
          [BaggageEventTypes.CLEAR_BAGGAGE_ERROR]: {
            actions: ActionTypes.clearBaggageError,
          },
        },
      },
    },
    config.stateOverride
  ),
});
